import CRUDActions from '../actions/CRUD';

class CRUDReducer {
  constructor(actionManager) {
    if (!(actionManager instanceof CRUDActions)) {
      throw 'actionManager has to be instance of CRUDActions';
    }

    this._actionManager = actionManager;
    this._redusers = this.getReducers(this._actionManager)
  }

  initState = { };

  /**
   *
   * @param CRUDActions actionManager
   * @returns {{}}
   */
  getReducers(actionManager) {
    let reducers = {};

    // create new model actions
    reducers[actionManager.createModelAction] = new CRUDCreateNewAction();

    // fetch list actions
    reducers[actionManager.fetchListAction] = new CRUDFetchListAction();
    reducers[actionManager.fetchListFinishedSuccessAction] = new CRUDFetchListFinishedSuccessAction();
    reducers[actionManager.fetchListFinishedFailAction] = new CRUDFetchListFinishedFailAction();

    // fetch list more actions
    reducers[actionManager.fetchListMoreAction] = new CRUDFetchListMoreAction();
    reducers[actionManager.fetchListMoreFinishedSuccessAction] = new CRUDFetchListMoreFinishedSuccessAction();
    reducers[actionManager.fetchListMoreFinishedFailAction] = new CRUDFetchListMoreFinishedFailAction();

    // fetch item action
    reducers[actionManager.fetchItemAction] = new CRUDFetchItemAction();
    reducers[actionManager.fetchItemFinishedSuccessAction] = new CRUDFetchItemFinishedSuccessAction();
    reducers[actionManager.fetchItemFinishedFailAction] = new CRUDFetchItemFinishedFailAction();

    // save actions
    reducers[actionManager.saveItemAction] = new CRUDSaveAction();
    reducers[actionManager.saveItemFinishedSuccessAction] = new CRUDSaveSuccessAction();
    reducers[actionManager.saveItemFinishedFailAction] = new CRUDSaveFailAction();

    // remove actions
    reducers[actionManager.removeItemAction] = new CRUDRemoveAction();
    reducers[actionManager.removeItemFinishedSuccessAction] = new CRUDRemoveSuccessAction();
    reducers[actionManager.removeItemFinishedFailAction] = new CRUDRemoveFailAction();

    reducers[actionManager.closeEditFormAction] = new ClearEditFormAction();

    return reducers;
  }

  run(state, action) {
    state = state || {
      loading: false,
      loadingMore: false,
      loadingItem: true,
      hasMore: false,
      model: null,
      list: [],
      items: {},
      ...this.initState
    };
    let {type, ...data} = action;

    if (this._redusers[type] !== undefined && this._redusers[type] instanceof ReduceAction) {
      return Object.assign({}, state, this._redusers[type].run(data, state));
    } else {
      return state;
    }
  }

}

export class ReduceAction {
  /**
   * run action
   *
   * @param Object data
   * @param Object currentState
   * @return Object
   */
  /*eslint  no-unused-vars: 0*/
  run(data, currentState = {}) {
    throw 'this action has to be overwrited';
  }
}

export class ClearEditFormAction extends ReduceAction {
  run(data, currentState = {}) {
    return {
      model: null
    };
  }
}

export class CRUDSaveAction extends ReduceAction {
  run() {
    return {
      savingItem: true
    };
  }
}

export class CRUDSaveSuccessAction extends ReduceAction {
  run(data, currentState) {
    let { model } = data;
    let savedObjectItems = {};
    savedObjectItems[model.id] = model;

    let newState = {
      savingItem: false,
      model,
      items: Object.assign({}, currentState.items, savedObjectItems)
    };

    if (currentState.list.indexOf(model.id) === -1) {
      newState.list = [model.id].concat(currentState.list);
    }

    return newState;
  }
}

export class CRUDSaveFailAction extends ReduceAction {
  run(data) {
    return {
      savingItem: false,
      error: data
    };
  }
}

export class CRUDRemoveAction extends ReduceAction {
  run() {
    return {
      loadingItem: true
    };
  }
}

export class CRUDRemoveSuccessAction extends ReduceAction {
  run(data, currentState) {
    try {
      let { model } = data;
      let items = Object.assign({}, currentState.items);
      let list = [].concat(currentState.list);
      let index = currentState.list.indexOf(model.id);

      if (items[ model.id ] !== undefined) {
        delete items[ model.id ];
      }

      if (index !== -1) {
        list.splice(index, 1);
      }

      return {
        loadingItem: false,
        items,
        list
      };
    }
    catch (e) {
      /* eslint no-console: 0 */
      console.error(e);
      return currentState;
    }
  }
}

export class CRUDRemoveFailAction extends ReduceAction {
  run(data) {
    return {
      loadingItem: false,
      error: data
    };
  }
}

// fetch item action

export class CRUDFetchItemAction extends ReduceAction {
  run() {
    return {
      loadingItem: true,
      // model: null,
      error: null
    };
  }
}

export class CRUDFetchItemFinishedSuccessAction extends ReduceAction {
  run(data, currentState) {
    let { model } = data;

    let fetchedObjectItems = {};
    fetchedObjectItems[model.id] = model;

    return Object.assign({}, currentState, {
      loadingItem: false,
      model,
      items: Object.assign({}, currentState.items, fetchedObjectItems),
      list: [model.id]
    });
  }
}


export class CRUDFetchItemFinishedFailAction extends ReduceAction {
  run(data) {
    let { error } = data;
    return {
      loadingItem: false,
      error
    };
  }
}

// fetch list actions
export class CRUDFetchListAction extends ReduceAction {
  run({query}) {
    return {
      loading: true,
      filter: query,
      list: [],
      items: {}
    };
  }
}

export class CRUDFetchListFinishedSuccessAction extends ReduceAction {
  run(data) {
    let { items } = data;
    let itemsStored = {};

    let list = items.map(item => {
      itemsStored[item.id] = item;
      return item.id;
    });

    return {
      loading: false,
      hasMore: data.hasMore,
      items: itemsStored,
      list
    };
  }
}

export class CRUDFetchListFinishedFailAction extends ReduceAction {
  run(data) {
    let { error } = data;

    return {
      loading: false,
      error
    };
  }
}

// fetch list actions
export class CRUDFetchListMoreAction extends ReduceAction {
  run() {
    return {
      loadingMore: true
    };
  }
}

export class CRUDFetchListMoreFinishedSuccessAction extends ReduceAction {
  run(data, state) {
    let { items, list } = state;
    let itemsFromServer = data.items;
    let newItemsStored = {};

    let newList = itemsFromServer.map(item => {
      newItemsStored[item.id] = item;
      return item.id;
    });

    return {
      loadingMore: false,
      hasMore: data.hasMore,
      items: Object.assign(items, newItemsStored),
      list: list.concat(newList)
    };
  }
}

export class CRUDFetchListMoreFinishedFailAction extends ReduceAction {
  run(data) {
    let { error } = data;

    return {
      loadingMore: false,
      error
    };
  }
}

// create new model actions
export class CRUDCreateNewAction extends ReduceAction {
  run(data) {
    let { model } = data
    return {
      loadingItem: false,
      model
    };
  }
}

export default CRUDReducer;



// WEBPACK FOOTER //
// ./src/reducers/CRUDReducer.js